import { createApp } from "vue";
import App from "./components/App/App.vue";
import { createPinia } from "pinia";
import router from "./router";
import Vue3Tour from "vue3-tour";
import "vue3-tour/dist/vue3-tour.css";
import { VueShowdownPlugin } from "vue-showdown";

import.meta.glob("vue3-tour/dist/vue3-tour.css");

const pinia = createPinia();
const app = createApp(App);
app.use(Vue3Tour);

import vuetify from "./plugins/vuetify";
import { authStore } from "./stores/authStore";

app.use(pinia);
app.use(authStore);
app.use(vuetify);
app.use(router);
app.use(VueShowdownPlugin, {
  flavor: "github",
  options: {
    emoji: false,
  },
});

app.directive("blur", {
  //  inserted: function (el) {
  //    /* @ts-expect-error  tbd*/
  //    el.onfocus = (ev) => ev.target.blur();
  //  },
});

app.mount("#root");
